import {
  SITE_COMPANY_NAME,
  SITE_CONTACT_LABEL,
  SITE_CONTACT_URL,
  SITE_LOGO_ALT,
  SITE_PRODUCT_NAME,
} from "@/constants/site";
import { AppLogo } from "@/components/atoms/AppLogo";
import { FlameLogo } from "@/components/atoms/FlameLogo";

type SiteFooterProps = {
  variant?: "default" | "compact";
  className?: string;
  extraNote?: string;
  showBrandMark?: boolean;
};

export function SiteFooter({
  variant = "default",
  className = "",
  extraNote,
  showBrandMark = false,
}: SiteFooterProps) {
  const year = new Date().getFullYear();

  if (variant === "compact") {
    return (
      <footer
        className={`border-t border-white/[0.08] px-6 py-4 text-center text-xs text-white/45 ${className}`}
      >
        {showBrandMark ? (
          <div className="mb-3 flex justify-center">
            <AppLogo to="/" size={28} showWordmark={false} />
          </div>
        ) : null}
        <p>
          © {year} {SITE_COMPANY_NAME}. {SITE_PRODUCT_NAME} is a product of{" "}
          <a
            href={SITE_CONTACT_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium text-white/60 underline-offset-2 hover:text-brand hover:underline"
          >
            {SITE_CONTACT_LABEL}
          </a>
          .
        </p>
        {extraNote ? <p className="mt-1 text-white/40">{extraNote}</p> : null}
      </footer>
    );
  }

  return (
    <footer
      className={`border-t border-white/[0.08] bg-surface-elevated/40 ${className}`}
    >
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-3 px-4 py-8 text-center sm:flex-row sm:px-6 sm:text-left lg:px-8">
        <div className="flex flex-col items-center gap-3 sm:flex-row sm:items-start sm:gap-4">
          <FlameLogo size={40} aria-label={SITE_LOGO_ALT} />
          <div>
            <p className="text-sm text-white/70">
              © {year} {SITE_COMPANY_NAME}. All rights reserved.
            </p>
            <p className="mt-1 text-xs text-white/45">
              {SITE_PRODUCT_NAME} is operated by {SITE_COMPANY_NAME}.
            </p>
          </div>
        </div>
        <a
          href={SITE_CONTACT_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="text-sm font-medium text-white/60 underline-offset-2 transition-colors hover:text-brand hover:underline"
        >
          {SITE_CONTACT_LABEL}
        </a>
      </div>
    </footer>
  );
}
